import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var JobApi = /** @class */ (function () {
    function JobApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    JobApi.initialize = function (basePath, fetchApi) {
        if (!JobApi.instance) {
            JobApi.instance = new JobApi(basePath, fetchApi);
        }
        return JobApi.instance;
    };
    JobApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1JobApi(new Configuration(config));
    };
    return JobApi;
}());
export { JobApi };
